import React from 'react';
import {
  Button,
  Menu,
  MenuItem,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowDownIcon } from '@hopper-b2b/ui-core';
import { ActiveFilter } from './JobsFilters';
import { FiltersEnum } from '@marketing-site/api/careers/apiSlice';

const FILTERS_MAP = {
  [FiltersEnum.Department]: 'Department',
  [FiltersEnum.Team]: 'Role',
  [FiltersEnum.Location]: 'Location',
  [FiltersEnum.EmploymentType]: 'Employment Type',
};

type FilterMenuProps = {
  label: FiltersEnum;
  options: string[];
  onSelect: (filter: ActiveFilter) => void;
};

export const FilterMenu = ({ label, options, onSelect }: FilterMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option: string) => {
    onSelect(option === 'All' ? null : { key: label, value: option });
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        size="small"
        fullWidth
        endIcon={<ArrowDownIcon />}
        sx={{
          borderRadius: '8px',
          border: '2px solid #D7DAE0',
          background: '#FFF',
          width: { mobile: '100%', tablet: '216px' },
        }}
      >
        <Stack direction="row" justifyContent={'space-between'} width="100%">
          <Typography variant={'body1'} fontSize={16} fontWeight={400}>
            {FILTERS_MAP[label]}
          </Typography>
        </Stack>
      </Button>
      <Menu
        id={`${label}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '8px',
              border: '2px solid #D7DAE0',
              background: '#FFF',
              width: { mobile: '100%', tablet: '216px' },
              boxShadow: 'unset',
            },
          },
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          sx: {
            padding: 0,
          },
        }}
      >
        <MenuItem value={'All'} onClick={() => handleMenuItemClick('All')}>
          All
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            onClick={() => handleMenuItemClick(option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
